import { inject, InjectionToken } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Paths } from '@config/paths.config';
import { DoodShopModel } from '@core/models/shop.model';
import { SlugUtils } from '@shared/utils/slug/slug.utils';
import { RouterHelperService } from '../router-helper/router-helper.service';
import { ShopKeys } from '@config/keys/shop.keys';
import { EntityKeys } from '@config/keys/entity.keys';

export const getShopHomePageUrl = (shop: DoodShopModel): string => {
  return `/${Paths.Shops}/${SlugUtils.formatSlug(shop[ShopKeys.Type].name)}/${shop[EntityKeys.Slug]}`;
};

export const navigateToShopPage = new InjectionToken(
  'An injectable function that helps to navigate to shop page home page',
  {
    providedIn: 'root',
    factory: () => {
      const router = inject(Router);
      const routerHelper = inject(RouterHelperService);
      return (
        shop: DoodShopModel,
        options?: {
          extraUrl?: string;
          extraConfig?: NavigationExtras;
        },
      ) => {
        router.navigate(
          [
            routerHelper.translateRoute(
              getShopHomePageUrl(shop) + (options?.extraUrl ? `/${options.extraUrl}` : ''),
            ),
          ],
          options?.extraConfig,
        );
      };
    },
  },
);
